import React from 'react';
import { X } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const pains = ['💸 Llegaste a mitad de mes y el dinero ya no alcanza', '😰 Tienes una deuda urgente que vence esta semana', '😓 Sabes que puedes generar más pero no sabes cómo ni por dónde empezar', '⏰ No tienes tiempo para buscar un segundo empleo formal', '🤯 Ya intentaste vender cosas pero no funcionó porque no tenías un sistema'];
export const ProblemBullets = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-131">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-132">
        <FadeIn data-id="element-133">
          <div className="text-center mb-12" data-id="element-134">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-135">
              ¿Te identificas?
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-136">
              ¿Te identificas con alguna de estas situaciones?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-137">
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 md:p-10" data-id="element-138">
            <ul className="space-y-5" data-id="element-139">
              {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-140">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center mt-0.5" data-id="element-141">
                    <X className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-142" />
                  </span>
                  <span className="text-base md:text-lg text-gray-300 leading-relaxed font-sans" data-id="element-143">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-144">
          <div className="mt-8 border-2 border-[#ADFF2F] bg-[#ADFF2F]/5 rounded-xl p-6 text-center" data-id="element-145">
            <p className="text-white text-lg md:text-xl font-medium font-sans m-0" data-id="element-146">
              Si dijiste <span className="text-[#ADFF2F] font-bold" data-id="element-147">SÍ</span> a
              cualquiera de estos puntos, este plan fue diseñado exactamente
              para ti 👇
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};